import { Link } from 'react-router-dom';
import { Icon, Button } from 'antd';
import PasswordResetCode410 from 'components/login/code/PasswordResetCode410';
import PasswordResetCode409 from 'components/login/code/PasswordResetCode409';
import PasswordResetCode424 from 'components/login/code/PasswordResetCode424';
import { ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';

const { SESSION_HOME } = ssSessionUtils;

// This is setup in such a way that if views need to follow status codes, it
// should be easy to add a status code in the submission process.

class Loading extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { code } = this.props;
        switch(code) {
            default: return (
                <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                    <Icon type='loading' style={{ fontSize: '20px', marginRight: '8px' }} />
                    <span style={{ fontSize: '20px' }}>
                        {'Loading...'}
                    </span>
                </div>
            );
        }
    }
}

class Pending extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { code, type } = this.props;
        switch(code) {
            default: return (
                <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                    <Icon type='loading' style={{ fontSize: '20px', marginRight: '8px' }} />
                    <span style={{ fontSize: '17px' }}>{
                        type === 'reset-password' ? 'Attempting to reset password...' :
                        type === 'expired-password' ? 'Attempting to update password...' : ''
                    }</span>
                </div>
            );
        }
    }
}

class Success extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { code, type, doClose } = this.props;
        switch(code) {
            default: return (
                <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                    <Icon type='check-circle-o' style={{ fontSize: '20px', marginRight: '8px' }} />
                    <span style={{ fontSize: '20px' }}>{
                        type === 'reset-password' ? 'Password successfully reset' :
                        type === 'expired-password' ? 'Password successfully updated' : ''
                    }</span>
                    <div style={{ margin: '20px 0px 0px 0px' }}>
                        <Link to={SESSION_HOME}>
                            <Button
                                size='small'
                                style={{ width: '200px', borderRadius: '20px' }}
                                onClick={doClose}
                            >
                                {'Ok'}
                            </Button>
                        </Link>
                    </div>
                </div>
            );
        }
    }
}

class Failure extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { code, service, type } = this.props;
        switch(code) {
            default: return (
                <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                    <span style={{ fontSize: '20px' }}>{
                        type === 'reset-password' ? 'Unable to reset password' :
                        type === 'expired-password' ? 'Unable to update password' : ''
                    }</span>
                    <div style={{ fontSize: '12px', fontWeight: 'normal', marginTop: '3px' }}>
                        {'For assistance please contact the FTSP Help Desk.'}
                    </div>
                    <div style={{ margin: '20px 0px 0px 0px' }}>
                        <Button
                            size='small'
                            onClick={service}
                            style={{ width: '200px', borderRadius: '20px' }}
                        >
                            {'Ok'}
                        </Button>
                    </div>
                </div>
            );
            case 409: return <PasswordResetCode409 service={service} type={type} />;
            case 410: return <PasswordResetCode410 service={service} />;
            case 424: return <PasswordResetCode424 service={service} />;
        }
    }
}

export default class PasswordResetModal extends React.Component {
    constructor(props) { super(props); }
    render() {
        const
        { services, state, toggleHandleSubmit, type, doClose } = this.props,
        { passwordReset } = state,
        props = {
            doClose,
            type,
            status:
                type === 'reset-password' ? passwordReset.passwordUpdateRequest.status :
                type === 'expired-password' ? passwordReset.expiredPasswordUpdateRequest.status : null,
            code:
                type === 'reset-password' ? passwordReset.passwordUpdateRequest.code :
                type === 'expired-password' ? passwordReset.expiredPasswordUpdateRequest.code : null
        };

        return (
            <div style={{
                display: passwordReset.showPasswordResetModal ? 'block' : 'none',
                width: '450px',
                padding: '20px',
                position: 'absolute',
                backgroundColor: 'rgb(238, 238, 238, .6)',
                boxShadow: 'rgb(194, 194, 194) 0px 0px 20px',
                borderRadius:
                    props.status === 'success' ? '16px' :
                    props.status === 'failure' ? '18px' : '40px',
                transform: 'translate(-50%, -50%)',
                top: '50%',
                left: '50%',
                overflow: 'auto'
            }}>{
                props.status === 'pending' ? <Pending {...props} /> :
                props.status === 'success' ? <Success {...props} /> :
                props.status === 'failure' ? (
                    <Failure {...props} service={() => {
                        services.togglePasswordResetModal();
                        toggleHandleSubmit();
                    }} />
                ) : <Loading />
            }</div>
        );
    }
}
